import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import AppRoutes from './routes/Routes'; // Your routes component
import { UserContextProvider } from './context/UserContext'; // Make sure this path is correct
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import { queryClient } from './lib/queryClient';

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>
        <ThemeProvider theme={theme}>
          <div>
            <AppRoutes /> {/* Your routing component */}
            <ToastContainer style={{ zIndex: 11000 }} />
          </div>
        </ThemeProvider>
      </UserContextProvider>
    </QueryClientProvider>
  );
};

export default App;
